<i18n>
{
	"en": {
		"stretches": "Stretches"
	},
	"no": {
		"stretches": "Strekninger"
	}
}
</i18n>

<template>
	<div style="width: 250px; height: 100%;">

		<div style="display: flex; align-items: baseline; margin-right: auto;">
			<span class="category-title">
				{{$t('stretches')}}
			</span>

			<div style="display: flex; margin-bottom: 5px;">
				<t-icon-button
					type="bp"
					icon="list"
					style="margin: 0 5px 0 0"
					appearance="minimal"
					tabindex="-1"
					:disabled="currentTab === 'list'"
					@click="setTab('list')"
				/>
				<t-icon-button
					type="bp"
					icon="diagram-tree"
					appearance="minimal"
					tabindex="-1"
					:disabled="currentTab === 'graph'"
					@click="setTab('graph')"
				/>
			</div>
		</div>
		<hr >

		<div>
			<sub-order-list
				v-if="currentTab === 'list'"
				@createParallelSuborder="$emit('createParallelSuborder',$event)"
				@selected="$emit('selected', $event)"
			/>
			<sub-order-graph
				v-else-if="currentTab === 'graph'"
				@createParallelSuborder="$emit('createParallelSuborder',$event)"
				@selected="$emit('selected', $event)"
			/>
		</div>
	</div>

</template>

<script>
import TIconButton from '@/components/evergreen/buttons/TIconButton';
import SubOrderList from '@/modules/newOrder/subOrders/SubOrderList';
import SubOrderGraph from '@/modules/newOrder/subOrders/SubOrderGraph';

export default {
	name: 'SubOrdersMain',
	components: { SubOrderList, TIconButton, SubOrderGraph },
	data() {
		return { currentTab: 'list' };
	},
	methods: {
		setTab(tab) {
			this.currentTab = tab;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.category-title {
	user-select: none;
	font-size: 10px;
	font-weight: 600;
	line-height: 1.45;
	letter-spacing: 0.3px;
	color: get-color($text, 'muted');
	text-transform: uppercase;
	margin-bottom: 2px;
	padding-bottom: 0;
	margin-right: auto;
}
hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
}

</style>